'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PRODUCTS;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SERASA = exports.SERASA = 'serasa';
var ECRED = exports.ECRED = 'ecred';
var ANTIFRAUDE = exports.ANTIFRAUDE = 'antifraude';
var PREMIUM = exports.PREMIUM = 'premium';
var LIMPA_NOME = exports.LIMPA_NOME = 'limpa-nome';
var SCORE = exports.SCORE = 'score';
var CADASTRO_POSITIVO = exports.CADASTRO_POSITIVO = 'cadastro-positivo';
var VOCE_CONSULTA = exports.VOCE_CONSULTA = 'voce-consulta';
var ENSINA = exports.ENSINA = 'ensina';
var CARTEIRA_DIGITAL = exports.CARTEIRA_DIGITAL = 'carteira-digital';

var EXTERNAL_SITE_MESSAGE = exports.EXTERNAL_SITE_MESSAGE = 'abre em site externo.';

var BREAKPOINT = exports.BREAKPOINT = {
  TABLET: '',
  DESKTOP: '1023px'
};

var PREFIX = '/lno/static-webfiles';
var PREFIX_PRODUCTS = PREFIX + '/common/products';

var PRODUCTS = exports.PRODUCTS = (_PRODUCTS = {}, _defineProperty(_PRODUCTS, SERASA, {
  key: SERASA,
  name: 'Serasa',
  url: '/',
  logo: PREFIX + '/logo/serasa.svg',
  logoWhite: PREFIX + '/logo/serasa-white.svg',
  logoGray: PREFIX + '/logo/serasa-gray.svg',
  square: PREFIX + '/logo/serasa-icon.svg'
}), _defineProperty(_PRODUCTS, ECRED, {
  key: ECRED,
  name: 'Serasa Crédito',
  url: '/credito/',
  logo: PREFIX_PRODUCTS + '/serasa-credito.svg',
  logoWhite: PREFIX_PRODUCTS + '/serasa-credito-white.svg',
  square: PREFIX_PRODUCTS + '/square/credito.svg'
}), _defineProperty(_PRODUCTS, ANTIFRAUDE, {
  key: ANTIFRAUDE,
  name: 'Serasa Antifraude',
  url: '/antifraude/',
  logo: PREFIX_PRODUCTS + '/antifraude.svg',
  logoWhite: PREFIX_PRODUCTS + '/antifraude-white.svg',
  square: PREFIX_PRODUCTS + '/square/antifraude.svg'
}), _defineProperty(_PRODUCTS, PREMIUM, {
  key: PREMIUM,
  name: 'Serasa Premium',
  url: '/premium/',
  logo: PREFIX_PRODUCTS + '/serasa-premium.svg',
  logoWhite: PREFIX_PRODUCTS + '/serasa-premium-white.svg',
  square: PREFIX_PRODUCTS + '/square/serasa-premium.svg'
}), _defineProperty(_PRODUCTS, LIMPA_NOME, {
  key: LIMPA_NOME,
  name: 'Serasa Limpa Nome',
  url: '/limpa-nome-online/',
  logo: PREFIX_PRODUCTS + '/limpa-nome.svg',
  logoWhite: PREFIX_PRODUCTS + '/limpa-nome-white.svg',
  square: PREFIX_PRODUCTS + '/square/limpa-nome.svg'
}), _defineProperty(_PRODUCTS, SCORE, {
  key: SCORE,
  name: 'Serasa Score',
  url: '/score/',
  logo: PREFIX_PRODUCTS + '/score.svg',
  logoWhite: PREFIX_PRODUCTS + '/score-white.svg',
  square: PREFIX_PRODUCTS + '/square/score.svg'
}), _defineProperty(_PRODUCTS, CADASTRO_POSITIVO, {
  key: CADASTRO_POSITIVO,
  name: 'Serasa Cadastro Positivo',
  url: '/cadastro-positivo/',
  logo: PREFIX_PRODUCTS + '/cadastro-positivo.svg',
  logoWhite: PREFIX_PRODUCTS + '/cadastro-positivo-white.svg',
  square: PREFIX_PRODUCTS + '/square/cadastro-positivo.svg'
}), _defineProperty(_PRODUCTS, VOCE_CONSULTA, {
  key: VOCE_CONSULTA,
  name: 'Você Consulta',
  url: '/voceconsulta/',
  square: PREFIX_PRODUCTS + '/square/vcep.svg'
}), _defineProperty(_PRODUCTS, CARTEIRA_DIGITAL, {
  key: CARTEIRA_DIGITAL,
  name: 'Serasa Carteira Digital',
  url: '/carteira-digital/',
  square: PREFIX_PRODUCTS + '/square/serasa-premium.svg'
}), _PRODUCTS);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/constants.js
// module id = 9
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38